<mat-card
    skeletonScreen
    [showSkeleton]="!summary"
    [placeholderHeight]="'1rem'"
    class="summary-card"
>
    <div
        class="image-wrapper"
        skeletonData
        [showSkeleton]="!summary || !isImageReady"
    >
        <img
            [src]="summary?.itemImagePath"
            class="mat-card"
            (load)="imageIsReady()"
            qa="selected-gift-card-design"
        />
    </div>
    <div class="purchase-details">
        <span class="recipient-note note">To:</span>
        <span
            class="recipient-name"
            skeletonData
            [placeholderWidth]="'12rem'"
            qa="recipient-name"
        >
            {{ summary?.recipientName }}
        </span>
        <span class="numeric-col">Total</span>
        <span
            class="recipient-email"
            skeletonData
            [placeholderWidth]="'12rem'"
            qa="receipient-email"
        >
            {{ summary?.recipientEmail }}
        </span>
        <span
            class="numeric-col price"
            skeletonData
            [placeholderWidth]="'5rem'"
            qa="item-total"
        >
            {{ summary?.itemTotal | dsiCurrency }}
        </span>
    </div>
    <div
        class="item-note note"
        *ngIf="summary?.itemNote?.length > 0"
        qa="item-note"
    >
        {{ summary.itemNote }}
    </div>
</mat-card>
